import React, { useState, useEffect } from 'react';
import HeaderPage from '../components/HeaderPage';
import { useBlogContext } from '../../fetchdata/BlogContext';

// Simple Skeleton Loader
const Skeleton = () => {
  return (
    <div className="p-3">
      <div className="skeleton mb-3" style={{ height: 200 }} />
      <div className="skeleton w-50 mb-2"></div>
      <div className="skeleton w-75 mb-2"></div>
      <div className="skeleton w-25 mb-2"></div>
      <div className="skeleton w-50"></div>
    </div>
  );
};

const StoreLocation = () => {
  const { Headers } = useBlogContext();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // simulate API delay
    const timer = setTimeout(() => setLoading(false), 1500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      <HeaderPage title={"Store Locator"} />

      <main className="page-content bg-light pb-5" style={{ minHeight: "100vh" }}>
        {loading ? (
          <Skeleton />
        ) : (
          <div className="container py-3" style={{ maxWidth: "600px" }}>
            {/* Map Section */}
            <div className="mb-3" style={{ borderRadius: "10px", overflow: "hidden" }}>
              <iframe
                title="store-map"
                src={`https://www.google.com/maps?q=${Headers.address}&output=embed`}
                width="100%"
                height="250"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>

            {/* Store Info */}
            <div className="bg-white p-3 rounded shadow-sm">
              <div className="d-flex justify-content-between align-items-center mb-2">
                <h6 className="fw-bold mb-0">{Headers.address}</h6>
                <button className="btn btn-sm btn-outline-dark rounded-pill px-3">
                  <i className="ri-navigation-fill me-2"></i>Direction
                </button>
              </div>

              <div className='d-flex'>
                <div className="col">

                  <a href={`tel:${Headers?.phone || ""}`} className="text-decoration-none text-dark small">
                    <i className="ri-phone-fill text-primary me-2"></i>
                    {Headers?.phone || ""}
                  </a>
                </div>

                <div className="col">

                  <a
                    href={`mailto:${Headers?.email || ""}`}
                    className="text-decoration-none text-dark small"
                  >
                    <i className="ri-mail-fill text-primary me-2"></i>
                    {Headers?.email || ""}
                  </a>
                </div>
              </div>

            </div>
          </div>
        )}
      </main >
    </>
  );
};

export default StoreLocation;
